/* unplugin-vue-components disabled */import script from "./ArticleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleDetail.vue?vue&type=style&index=0&id=5c69bc11&lang=scss"

const __exports__ = script;

export default __exports__